import { render, staticRenderFns } from "./EmailUpsell.vue?vue&type=template&id=3ee7f7c4"
import script from "./EmailUpsell.vue?vue&type=script&lang=js"
export * from "./EmailUpsell.vue?vue&type=script&lang=js"
import style0 from "./EmailUpsell.vue?vue&type=style&index=0&id=3ee7f7c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports